<div class="max-w-full mx-auto">
  <mat-accordion class="mx-auto w-3/4 shadow-lg">
    <mat-expansion-panel>
      <mat-expansion-panel-header class="bg-gray-100 shadow-md text-white">
        <mat-panel-title class="flex items-center">
          <i class="fas fa-filter text-orange-400 mr-2"></i>
          Filtrar el registro de eventos de facturación
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="p-6 bg-white shadow rounded-lg">
        <form class="space-y-6" [formGroup]="filterForm">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Fecha de inicio</mat-label>
              <input matInput type="date" formControlName="billing_start_date">
            </mat-form-field>
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Fecha de fin</mat-label>
              <input matInput type="date" formControlName="billing_end_date">
            </mat-form-field>
          </div>

          <div *ngIf="showAdvancedOptions" class="space-y-6">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Buscar en logs</mat-label>
                <input matInput formControlName="log" placeholder="Texto de log...">
              </mat-form-field>
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Selecciona un evento</mat-label>
                <mat-select formControlName="event">
                  <mat-option value="billing_process_opened">Apertura de Proceso de Facturación</mat-option>
                  <mat-option value="billing_process_closed">Cierre de Proceso de Facturación</mat-option>
                  <mat-option value="bill_sent_event">Evento de Factura Enviada</mat-option>
                  <mat-option value="provider_not_available">Proveedor No Disponible</mat-option>
                  <mat-option value="bill_created_event">Evento de Factura Creada</mat-option>
                  <mat-option value="biller_not_available">Facturador No Disponible</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="flex justify-center gap-2">
            <button (click)="applyFilters()" type="submit"
              class="bg-orange-500 text-white font-bold py-3 px-6 rounded-lg hover:bg-orange-700 transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-opacity-50">
              Aplicar filtros
            </button>
            <button type="button" (click)="clearFilters()"
              class="bg-red-500 text-white font-bold py-3 px-6 rounded-lg hover:bg-red-700 transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-opacity-50">
              Limpiar Filtros
            </button>
          </div>
          <div class="text-center py-4">
            <button type="button" (click)="toggleAdvancedOptions()"
              class="bg-gray-200 text-gray-400 font-semibold py-2 px-4 rounded hover:bg-gray-300 transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 shadow hover:shadow-md">
              {{ showAdvancedOptions ? 'Menos opciones' : 'Opciones avanzadas' }}
            </button>
          </div>
        </form>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <div *ngIf="activities && activities.length > 0" class="mt-8">
    <h2 class="text-3xl font-semibold text-center text-gray-800 mb-3 uppercase">REGISTRO DE EVENTOS DEL PROCESO DE
      FACTURACIÓN</h2>
    <div class="overflow-x-auto shadow-lg rounded-lg rounded-b-none">
      <table class="w-full leading-normal">
        <thead class="bg-orange-500 text-white">
          <tr>
            <th class="px-5 py-3 border-b-2 border-orange-600">Elementos</th>
            <th class="px-5 py-3 border-b-2 border-orange-600">Fecha</th>
            <th class="px-5 py-3 border-b-2 border-orange-600">Descripción</th>
            <th class="px-5 py-3 border-b-2 border-orange-600">Inicio Facturación</th>
            <th class="px-5 py-3 border-b-2 border-orange-600">Fin Facturación</th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr *ngFor="let activity of activities; let i = index; even as isEven"
            class="hover:bg-gray-200 transition duration-150 ease-in-out">
            <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ getIndex(i) }}</td>
            <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ activity.date || '-' }}</td>
            <td class="px-5 py-5 border-b border-gray-200 text-left align-middle"
              [innerHTML]="activity.descriptionAsArray| descriptionArrayPipe"></td>
            <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ activity.billingStartDate ||
              '-' }}</td>
            <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ activity.billingEndDate || '-'
              }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="activities.length === 0 && !isLoading" class="bg-white shadow-md rounded-lg mt-5 p-7">
      <h1 class="text-2xl font-bold text-center text-gray-600">No se encontraron eventos</h1>
    </div>

    <div *ngIf="activities.length > 0">
      <div class="relative mb-5">
        <mat-paginator [length]="listEventRegistry.totalElements" hidePageSize="true" [pageSizeOptions]="[10, 20, 50]"
          [showFirstLastButtons]="true" aria-label="Select page of activities" (page)="handlePageEvent($event)">
        </mat-paginator>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="absolute inset-0 flex items-center justify-center bg-white opacity-75">
    <mat-spinner class="text-orange-500 animate-spin" strokeWidth="3" [diameter]="70"></mat-spinner>
  </div>
</div>